<template>
    <div class="relative dashboard-page">
        <PaymentModal
    v-if="$store.state.paymentModal"
    @close="
        () => {
            $store.commit('setPaymentModal', false)
        }
    "/>
        <template v-if="$store.state.showAppFilters">
            <AppFilter
                :mile="miles"
                :filter-category="filterCategory"
                :cause="causeSingle"
                :tag="tagActive"
                :search-title="searchTitle"
                @changeFilterData="changeFilterData"
                @searchCausesByTitle="searchCausesByTitle"
            ></AppFilter>
        </template>

        <template v-else>
            <div class="page-logo-container-fallback fixed left-0 top-0"></div>
            <div
                class="page-logo-container flex justify-center items-center fixed left-0 top-0 pb-4 px30"
            >
                <div
                    class=""
                    :class="{
                        'is-corporation': $getState('corporation')['is']
                    }"
                >
                    <div class="image-wrapper">
                        <img
                            class="page-logo"
                            :srcset="
                                `${$store.state.appUrl}/img/pwa/login/login-logo.png, ${$store.state.appUrl}/img/pwa/login/login-logo@2x.png 2x`
                            "
                            :src="`${$store.state.appUrl}/img/pwa/login/login-logo.png`"
                            alt="Thrive"
                            width="245px"
                            height="56px"
                        />
                    </div>

                    <div class="image-wrapper">
                        <img
                            class="corp-logo"
                            v-if="$getState('corporation')['is']"
                            :src="corporationLogo"
                            :alt="corporationTitle"
                        />
                    </div>
                </div>
            </div>
            <div class="page-content-container">
                <div class="empty-block opacity-0"></div>
                <div class="page-content px30 bg-white relative z-10">
                    <div class="user-info flex items-center">
                        <span class="user-avatar">
                            <img
                                v-if="$user('avatar') && $user('has_avatar')"
                                :src="$user('avatar')"
                            />
                            <UserAvatar v-else />
                        </span>
                        <span
                            class="user-name font-bold text-20 text-text tracking-normal"
                        >
                            {{ $user("name") }}
                        </span>
                    </div>
                    <h3 class="text-28 font-bold tracking-tight text-text mb-2">
                        {{ $t("You Are A Changemaker") }}
                    </h3>
                    <p
                        class="tracking-normal text-12 text-text opacity-60 mb-5"
                    >
                        {{
                            $t(
                                "Your change allows us to support local causes and gives you discounts at shops and restaurants!"
                            )
                        }}
                    </p>
                    <div class="page-content-map relative">
                        <GoogleMap
                            :miles="miles"
                            :causes="retailersMap"
                            route-path="/locations"
                        ></GoogleMap>
                    </div>
                    <div class="pb-16">
                        <Giving />
                    </div>
                    <div class="current-cause">
                        <div class="flex items-end mb-5">
                            <h3
                                class="flex-grow color-text font-bold text-20 tracking-normal leading-tight pr-2"
                            >
                                <span class="text-primary">{{
                                    $t("Your")
                                }}</span>
                                {{ $t("Current Cause") }}
                            </h3>
                            <router-link
                                :to="{
                                    name: 'Non-profit organizations',
                                    params: { back: '/dashboard' }
                                }"
                                class="text-14 tracking-normal text-cause_text"
                            >
                                <span v-if="hasCauses">{{ $t("Change") }}</span>
                                <span v-else>{{ $t("Add") }}</span>
                            </router-link>
                        </div>
                        <template v-if="hasCauses">
                            <router-link
                                v-for="cause in causes"
                                :to="`npos/${cause.id}`"
                                :key="cause.id"
                            >
                                <CauseItem
                                    :click-handler="clickCause"
                                    :cause="cause"
                                    view="block"
                                    :is-select="false"
                                    :key="cause.id"
                                ></CauseItem>
                            </router-link>
                        </template>
                    </div>
                    <div class="mb-16">
                        <Extra />
                    </div>
                    <Impact />
                </div>
            </div>
            <Navigation />
        </template>
    </div>
</template>

<script>
import Navigation from "../components/Navigation/Navigation";
import GoogleMap from "../components/GoogleMap/GoogleMap";
import Giving from "../components/Giving/Giving";
import CauseItem from "../components/Cause/CauseItem";
import Extra from "../components/Giving/Extra";
import Impact from "../components/Giving/Impact";
import AppFilter from "../components/Filters/AppFilter";
import UserAvatar from "../components/Icons/UserAvatar";
import mixins from "../config/mixins";
import SvgIcon from "../components/UI/SvgIcon";
import PaymentModal from "../components/Modal/PaymentModal";

export default {
    name: "Dashboard",

    mixins: [mixins.npos, mixins.plaid],

    components: {
        SvgIcon,
        UserAvatar,
        Impact,
        Extra,
        CauseItem,
        Giving,
        GoogleMap,
        Navigation,
        AppFilter,
        PaymentModal
    },

    data() {
        return {
            causes: [],
            causesMap: [],
            hasCauses: false,
            miles: 1,
            filterCategory: [],
            causeSingle: {},
            tagActive: null,
            searchTitle: "",
            monthDonation: 0,
            retailersMap: []
        };
    },

    watch: {
        "$store.state.userLocation": function() {
            this.getPartnersInMyLocation();
        }
    },

    created() {
        this.$checkAvatar(this.$user("has_avatar"));
    },

    mounted() {
        this.$setState("showGoogleMap", false);
        this.$setState("showAppFilters", false);
        this.$setState("isNavigation", true);
        this.getUserNpos();
        this.$scrollToTop();
        this.WhichUser();
    },

    computed: {
        corporationTitle: function() {
            const corpData = this.$getState("corporation");
            if (!!corpData.title && corpData.title.length) {
                return this.getLocalizationData(corpData.title);
            }

            return "";
        },

        corporationLogo: function() {
            const corpData = this.$getState("corporation");
            if (!!corpData.logo && corpData.logo) {
                return this.getNposImage(corpData.logo);
            }
            return "";
        }
    },

    methods: {
        clickHandler: function() {
            this.recreate = 0;
            this.plaidLoad();
        },
        clickCause: function() {
            return false;
        },
        getUserNpos: function() {
            this.$http.post("user/listnpo").then(res => {
                if (res && res.status !== undefined && res.status) {
                    if (res.data.npo !== undefined) {
                        this.causes = res.data.npo;
                        if (this.causes && this.causes.length > 0) {
                            this.hasCauses = true;
                        }
                    }
                }
            });
        },
        changeFilterData: function(miles, category) {
            this.miles = miles;
            this.filterCategory = category;
        },
        searchCausesByTitle: function(title) {
            this.searchTitle = title;
        },
        getPartnersInMyLocation: function() {
            let location = this.$getState("userLocation");
            this.$http
                .post("retailer/list", {
                    limit: 100,
                    location: {
                        center_lat: location.lat,
                        center_lng: location.lng,
                        dist: 100
                    }
                })
                .then(res => {
                    if (res && res.status !== undefined && res.status) {
                        this.retailersMap = res.data.retailers;
                    }
                });
        },
       
      WhichUser: function(){
            this.$http.post("user/useronline").then(data => {
                 if(data.data.plaid_env == "development")
                 {
                    this.$store.commit('setPaymentModal', true)
                 }
                   /* if (data && data.status !== undefined && data.status) {
                        const user = data.data.user;
                        app.$setState("userUpdate", user);
                        if (user.pr_card && app.$route.path === "/login") {
                            app.$emit("goNextCardProcess", "donation");
                        }

                        if (app.$route.path === "/settings") {
                            app.$emit("actionWithCard", {
                                action: "update",
                             });
                        }
                    }*/
                });
        },
    }
};
</script>
